import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      enums: {
        DROPOUT: 'DROPOUT',
        UTILISATION: 'UTILIZATION',
      },
    }
  }
}
